import * as React from "react";
import Breadcrumb from "./breadcrumb";
import { RouteComponentProps, withRouter } from "react-router-dom";

export interface NavItem {
    name: string;
    target: string | undefined;
}

interface Props extends RouteComponentProps {
    readonly items: readonly NavItem[];
    readonly onItemRename?: (item: NavItem, newName: string) => void;
}

interface State {}

class NavBreadcrumbImpl extends React.PureComponent<Props, State> {
    public state: State = {};

    private onItemClicked = (item: NavItem) => {
        if (item.target === undefined) return;
        this.props.history.push(item.target);
    };

    public render(): React.ReactNode {
        const { items, onItemRename } = this.props;
        return (
            <Breadcrumb
                items={items}
                currentItem={items[items.length - 1]}
                nameForItem={t => t.name}
                onItemClicked={this.onItemClicked}
                onItemRename={onItemRename}
            />
        );
    }
}

const NavBreadcrumb = withRouter(NavBreadcrumbImpl);
export default NavBreadcrumb;
